import { applicationActions } from "../actions/actions";
import { E_Modification, resolvePolymorphVar } from "@green24/npm-javascript-utils";
import { StoreThunk } from "@green24/npm-preact-utils/store";
import { applicationSelector } from "../selectors/selectors";

const Thunk_modifyApplicationData = (value, path, type = E_Modification.ITEM_SET) => {
	return (dispatch) => {
		dispatch(applicationActions.getEditModify(value, path, type));
	}
};

const Thunk_setReturnData = (returnData) => {
	let [url, title] = resolvePolymorphVar(
		returnData,
		{
			object: o => [o.url, o.title],
			array: arr => [arr[0], arr[1]],
			string: s => [s],
		},
		[returnData]
	)

	return Thunk_setReturnURL(url, title);
};

const Thunk_setReturnURL = (url, title) => {
	url = url === '.' ? window.location.pathname : url;

	return (dispatch) => {
		dispatch(applicationActions.getEditModify({
			url,
			title,
		}, "return", E_Modification.ITEM_SET));
	}
};

const Thunk_setIdleTimeout = (time) => {
	return (dispatch, getState) => {
		if(time === undefined) {
			time = applicationSelector.selectData(getState()).redirectTimeout;
		}

		dispatch(applicationActions.getEditModify(time, "idleTimeout", E_Modification.ITEM_SET));
	}
}

export class Thunk_Application extends StoreThunk {
	modifyApplicationData(value, path, type = E_Modification.ITEM_SET) {
		return this.connect(Thunk_modifyApplicationData(value, path, type));
	}

	setReturnData(returnData) {
		return this.connect(Thunk_setReturnData(returnData));
	}

	setIdleTimeout(time) {
		if(time === undefined) {
			time = applicationSelector.selectData(this.getState()).redirectTimeout;
		}

		return this.connect(Thunk_setIdleTimeout(time));
	}
}
